import { IContaChatHistorico } from "../../../Interfaces/HelpDesk/ContaChatHistorico/ContaChatHistoricoInterface";
import {
    CadastrarContaChatHistoricoService,
    DeletarContaChatHistoricoService,
    GetContaChatHistoricoPorTelefoneService,
    GetContaChatHistoricoService,
} from "../../../Services/HelpDesk/ContaChat/ContaChatService";

import { Controller } from "../../Controller";

export async function CadastrarContaChatHistoricoController(
    requestBody: IContaChatHistorico
) {
    return Controller(CadastrarContaChatHistoricoService(requestBody));
}

export async function DeletarContaChatHistoricoController(
    idContaChatHistorico: number
) {
    return Controller(DeletarContaChatHistoricoService(idContaChatHistorico));
}

export async function GetContaChatHistoricoController(idContaChat: number) {
    return Controller(GetContaChatHistoricoService(idContaChat));
}

export async function GetContaChatHistoricoPorTelefoneController(
    nrTelefone: string
) {
    return Controller(GetContaChatHistoricoPorTelefoneService(nrTelefone));
}
